import { AppBar, Box, Toolbar } from '@mui/material';
import React from 'react';

interface IActionsFooterProps {
	children: React.ReactElement[];
}

const ActionsFooter: React.FC<IActionsFooterProps> = ({ children }) => (
	<AppBar
		position="sticky"
		component="footer"
		color="transparent"
		sx={{
			borderTop: 1,
			borderColor: 'divider',
			boxShadow: 'none'
		}}
	>
		<Toolbar>
			<Box display="flex" flexDirection="row" flexGrow={1}>
				{children}
			</Box>
		</Toolbar>
	</AppBar>
);

export default ActionsFooter;
